<template>
  <div class="div-style">
      <!--<div >-->
        <el-form :model="form" :rules="rules" ref="form"class="searchCard-box">
      <el-row>
        <el-col :span="8">
          <div class="grid-content-sh bg-head-purple">夜間搬入申込みサービス</div>
        </el-col>

        <el-col :span="16">
          <div class="grid-content2-sh bg-head-purple">夜間搬入状況確認</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" class="bg-purple-sh">
          <el-row>
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="grid-content-sh">レポート種別</div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="16">
          <div class="grid-content-sh bg-right-purple" ref="sub">
            <div style="text-align: left; padding-left: 10%;line-height: 28px">
              <el-radio v-model="radio" :label="1" @change="radioclick1()"><span>搬入日別一覧表</span></el-radio>
              <br>
              <el-radio v-model="radio" :label="2" @change="radioclick2()"><span>会社別搬入情報一覧表</span></el-radio>
              <br>
              <el-radio v-model="radio" :label="3" @change="radioclick3()"><span>当日搬入時間単位搬入品目件数状況一覧表</span></el-radio>
              <br>
              <el-radio v-model="radio" :label="4" @change="radioclick4()"><span>当日搬入時間単位予約トラック台数状況一覧表</span></el-radio>
              <br>
              <el-radio v-model="radio" :label="5" @change="radioclick5()"><span>指定日搬入時間単位搬入品目件数状況</span></el-radio>
              <br>
              <el-radio v-model="radio" :label="6" @change="radioclick6()"><span>指定日搬入時間単位予約トラック台数状況</span></el-radio>
            </div>
          </div>
        </el-col>
      </el-row>
      <hr style="width: 96%; font-size: 0;margin: 1px 2% 1px 2%;"/>
      <el-row>
        <el-col :span="8" class="bg-purple2-sh">
          <el-row>
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="grid-content-sh">指定日付</div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="16">
          <div class="grid-content-sh bg-right-purple" ref="dateTable">
            <div style="text-align: left; padding-left: 10%;line-height: 28px">
              <p style="font-size: 14px;">本日の日付を基本的に表示、変更可能</p>
              <el-form-item
                prop="dateTime">
                <el-date-picker
                  v-model="form.dateTime"
                  type="daterange"
                  align="right"
                  start-placeholder="from"
                  end-placeholder="to"
                  :editable="false"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <p style="font-size: 14px;">カレンダーの画面上でfrom,toを各々クリックしてください</p>
              <p style="font-size: 14px;">from日付単体設定で、その日一日の情報表示</p>
              <p style="font-size: 14px;">toに指定日を設定で一覧表の範囲設定が可能</p>
              <p style="font-size: 14px;">fromとtoが同じの場合には一日分の情報表示</p>
            </div>

          </div>
        </el-col>
      </el-row>
      <div style="width: 96%; font-size: 0;margin: 2px 2% 2px 2%;"></div>
      <el-row>
        <el-col :span="8" class="bg-purple3-sh">
          <div class="grid-content-sh">
            <div style="line-height: 32px">Excel出力の選択</div>
          </div>
        </el-col>

        <el-col :span="16">
          <div class="grid-content-sh bg-right-purple">

            <div style="text-align: left; padding-left: 10%;">
              <el-checkbox v-model="checked" @change="excle">Excel出力</el-checkbox>
                <!--<el-radio :label="1"><span>Excel出力</span></el-radio>-->
            </div>
            <div style="text-align: left; padding-left: 10%;" v-if="this.checked && this.isdey">
              <el-radio v-model="radio2" :label="1"><span>月間</span></el-radio>
              <el-radio v-model="radio2" :label="2"><span>４半期</span></el-radio>
              <br>
              <el-radio v-model="radio2" :label="3"><span>半期</span></el-radio>
              <el-radio v-model="radio2" :label="4"><span>年間</span></el-radio>
            </div>
            <div style="text-align: left; padding-left: 10%;" v-else="">
              <el-radio v-model="radio2" :label="1" disabled><span>月間</span></el-radio>
              <el-radio v-model="radio2" :label="2" disabled><span>４半期</span></el-radio>
              <br>
              <el-radio v-model="radio2" :label="3" disabled><span>半期</span></el-radio>
              <el-radio v-model="radio2" :label="4" disabled><span>年間</span></el-radio>
            </div>
          </div>
        </el-col>
      </el-row>
      <div style="margin-top: 1em;text-align: center;">
        <el-button type="danger" @click.native.prevent="submitForm('form')"><i class="el-icon-caret-right" style="color: white;"></i>確　認</el-button>
          <el-button type="danger" @click.native.prevent="clean()"><i class="el-icon-caret-right"style="color: white;"></i>終　了</el-button>
      </div>
      </el-form>
    <!--</div>-->
  </div>
</template>
<script>
  import http from '../../assets/js/http'
  import _g from '../../assets/js/global'
  import timeChe from '../../assets/js/timeChe'
  export default {
    data() {
      var checkDate = (rule, value, callback) => {
        if (typeof (this.form.dateTime) === 'undefined' || this.form.dateTime.length === 0) {
          callback(new Error('カレンダーの画面上でfrom,toを各々クリックしてください。'))
        }
        let time = this.form.dateTime[1].getTime() - this.form.dateTime[0].getTime()
        let days = Math.floor(time / 86400000)
        if (days > 366) {
          callback(new Error('fromとtoの時間は1年より大きい'))
        } else {
          callback()
        }
      }
      return {
        radio: 1,
        isdey: false,
        checked: false,
        newDateTime: [],
        dayListData: [],
        companyListData: [],
        typeData: [],
        pickerOptions: {
          disabledDate(time) {
            if (time.getTime() + (3600 * 1000 * 24 * 366) <= Date.now() || time.getTime() - (3600 * 1000 * 24 * 366) >= Date.now()) {
              return true
            } else {
              return false
            }
          },
          shortcuts: [{
            text: '最近一週間',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一月間',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三月間',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]

        },
        radio2: '',
        form: {
          dateTime: [new Date(), new Date()]
        },
        rules: {
          dateTime: [
            { required: true, message: 'カレンダーの画面上でfrom,toを各々クリックしてください。', trigger: 'change' },
            { required: true, validator: checkDate, trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      clean() {
        window.localStorage.setItem('userId', '')
        window.localStorage.setItem('loginRoot', '')
        this.resetCommonData('/shanaikanrisha/login')
        _g.toastMsg('warning', 'ログアウトしました！')
      },
      dayList(fileName) {
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['搬入日付', '20時', '21時', '22時', '23時', '24時(0時)', '25時(1時)', '26時(2時)', '27時(3時)', '28時(4時)', '29時(5時)', '30時(6時)', '31時(7時)', '32時(8時)']
          const filterVal = ['reserved_ymd', 'T20', 'T21', 'T22', 'T23', 'T24', 'T25', 'T26', 'T27', 'T28', 'T29', 'T30', 'T31', 'T32']
          const list = this.dayListData
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: fileName,
            autoWidth: true
          })
        })
      },
      companyList(fileName) {
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['確認', '受付番号', '会社名', '運送会社名', '車両', '車両その他', '搬入日時', '搬入品目', '搬入品目その他', '夜間連絡先', '備考']
          const filterVal = ['reserved_status', 'reserved_id', 'company_name', 'truck_comp_name', 'truck_type_name', 'truck_type_other', 'reserved_ymd', 'item_type_name', 'item_other', 'truck_tel', 'prepare']
          const list = this.companyListData
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: fileName,
            autoWidth: true
          })
        })
      },
      itemEx(fileName) {
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['', '日付', '20', '21', '22', '23', '24(0時)', '25(1時)', '26(2時)', '27(3時)', '28(4時)', '29(5時)', '30(6時)', '31(7時)', '32(8時)', '品目計']
          const filterVal = ['item_type_name', 'reserved_ymd', 'T20', 'T21', 'T22', 'T23', 'T24', 'T25', 'T26', 'T27', 'T28', 'T29', 'T30', 'T31', 'T32', 'item_type_sum']
          const list = this.typeData
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: fileName,
            autoWidth: true
          })
        })
      },
      truckEx(fileName) {
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['', '日付', '20', '21', '22', '23', '24(0時)', '25(1時)', '26(2時)', '27(3時)', '28(4時)', '29(5時)', '30(6時)', '31(7時)', '32(8時)', '品目計']
          const filterVal = ['truck_type_name', 'reserved_ymd', 'T20', 'T21', 'T22', 'T23', 'T24', 'T25', 'T26', 'T27', 'T28', 'T29', 'T30', 'T31', 'T32', 'truck_type_sum']
          const list = this.typeData
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: fileName,
            autoWidth: true
          })
        })
      },
      radioclick1() {
        this.isdey = true
      },
      radioclick2() {
        this.isdey = true
      },
      radioclick3() {
        this.form.dateTime = [new Date(), new Date()]
        this.isdey = false
      },
      radioclick4() {
        this.form.dateTime = [new Date(), new Date()]
        this.isdey = false
      },
      radioclick5() {
        this.isdey = true
      },
      radioclick6() {
        this.isdey = true
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        }))
      },
      excle() {
        if (!this.checked) {
          this.radio2 = ''
          // this.form.dateTime = [new Date(), new Date()]
        } else {
          if (this.radio === 3 || this.radio === 4) {
            this.isdey = false
            this.radio2 = ''
          } else {
            this.isdey = true
          }
          // var endDate = this.AddDays(this.form.dateTime[0], 13)
          // this.form.dateTime = [new Date(), endDate]
        }
      },
      AddDays(date, value) {
        // date.setDate(date.getDate() + value)
        var newDate = new Date(date.getTime() + 3600 * 1000 * 24 * value)
        return newDate
      },
      AddMonths(date, value) {
        date.setMonth(date.getMonth() + value)
        return date
      },
      submitForm(form) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('msie') != -1 || ua.indexOf('trident/7') != -1) {
          if (window.event.which == 13) {
            return false
          }
        }
        if (!this.checked && this.form.dateTime === null) {
          _g.toastMsg('error', '日付を指定してください。')
          return
        }
        if (this.checked) {
          var newEndDate1 = ''
          if (this.form.dateTime === null) {
            if (this.radio2 === '') {
              newEndDate1 = this.AddDays(new Date(), 14)
            } else if (this.radio2 === 1) {
              newEndDate1 = this.AddDays(new Date(), 30)
            } else if (this.radio2 === 2) {
              newEndDate1 = this.AddDays(new Date(), 90)
            } else if (this.radio2 === 3) {
              newEndDate1 = this.AddDays(new Date(), 180)
            } else if (this.radio2 === 4) {
              newEndDate1 = this.AddDays(new Date(), 366)
            }
            this.form.dateTime = [new Date(), newEndDate1]
          } else {
            if (this.radio2 === '') {
              newEndDate1 = this.form.dateTime[1]
            } else if (this.radio2 === 1) {
              newEndDate1 = this.AddDays(this.form.dateTime[0], 30)
            } else if (this.radio2 === 2) {
              newEndDate1 = this.AddDays(this.form.dateTime[0], 90)
            } else if (this.radio2 === 3) {
              newEndDate1 = this.AddDays(this.form.dateTime[0], 180)
            } else if (this.radio2 === 4) {
              newEndDate1 = this.AddDays(this.form.dateTime[0], 366)
            }
            this.form.dateTime = [this.form.dateTime[0], newEndDate1]
          }
        }
        if (this.radio == 3 || this.radio == 4) {
          this.form.dateTime = [new Date(), new Date()]
        }
        var month0 = (this.form.dateTime[0].getMonth() + 1) < 10 ? '0' + (this.form.dateTime[0].getMonth() + 1).toString() : (this.form.dateTime[0].getMonth() + 1).toString()
        var month1 = (this.form.dateTime[1].getMonth() + 1) < 10 ? '0' + (this.form.dateTime[1].getMonth() + 1).toString() : (this.form.dateTime[1].getMonth() + 1).toString()
        var day0 = this.form.dateTime[0].getDate() < 10 ? '0' + this.form.dateTime[0].getDate().toString() : this.form.dateTime[0].getDate().toString()
        var day1 = this.form.dateTime[1].getDate() < 10 ? '0' + this.form.dateTime[1].getDate().toString() : this.form.dateTime[1].getDate().toString()
        var fromDate = this.form.dateTime[0].getFullYear().toString() + month0 + day0
        var toDate = this.form.dateTime[1].getFullYear().toString() + month1 + day1
        var userId = window.localStorage.getItem('userId')
        this.$refs[form].validate((valid) => {
          if (valid) {
            if (userId === '') {
              _g.toastMsg('error', 'ログインしてください。')
              this.resetCommonData('/shanaikanrisha/login')
              return
            }
            let data = {}
            data.fromDate = fromDate
            data.toDate = toDate
            data.userId = userId
            if (this.radio === 1) {
              if (this.checked === true) {
                this.apiPost('shanaikanrisha/ReservedDayList/reservedDayList', data).then((res) => {
                  this.handelResponse(res, (data) => {
                    if (res.code != 200) {
                      this.loading = !this.loading
                      this.handleError(res)
                    } else {
                      this.dayListData = data.list
                      this.dayList('社内向け予約状況一覧表示')
                    }
                  })
                })
              } else {
                this.$router.push({ path: '/shanaikanrisha/dayList', query: { fromDate: fromDate, toDate: toDate, userId: userId, radio: this.radio, dateTime: this.form.dateTime }})
              }
              // this.resetCommonData('/shanaikanrisha/dayList')
            } else if (this.radio === 2) {
              if (this.checked === true) {
                this.apiPost('shanaikanrisha/CompanyList/companyList', data).then((res) => {
                  this.handelResponse(res, (data) => {
                    if (res.code != 200) {
                      this.loading = !this.loading
                      this.handleError(res)
                    } else {
                      let dataList = data.list
                      var a = data.list.forEach(function (item, index, input) {
                        if ((item.truck_tel_kaiban === '' || item.truck_tel_kaiban === null) && (item.truck_tel_kyokuban === '' || item.truck_tel_kyokuban === null)) {
                          dataList[index].truck_tel = item.truck_tel_siban
                        } else {
                          dataList[index].truck_tel = item.truck_tel_siban + '-' + item.truck_tel_kaiban + '-' + item.truck_tel_kyokuban
                        }
                        // if ((item.ITEM_TYPE_CD === '10011')) {
                        //   dataList[index].item_other = item.item_other
                        // } else {
                        //   dataList[index].item_other = ''
                        // }
                        dataList[index].reserved_ymd = item.reserved_ymd + '　' + timeChe.gettimeChe(item.reserved_time)
                        if (item.reserved_status === '0') {
                          dataList[index].reserved_status = '取消'
                        } else if (item.reserved_status === '2') {
                          dataList[index].reserved_status = '確定'
                        }
                      })
                      this.companyListData = dataList
                      this.companyList('社内向け会社別搬入情報一覧')
                    }
                  })
                })
              } else {
                this.$router.push({
                  path: '/shanaikanrisha/companyList',
                  query: { fromDate: fromDate, toDate: toDate, userId: userId, radio: this.radio, dateTime: this.form.dateTime }
                })
              }
            } else if (this.radio === 3) {
              if (this.checked === true) {
                this.apiPost('shanaikanrisha/ItemTypeSameDayList/itemTypeSameDayList', data).then((res) => {
                  this.handelResponse(res, (data) => {
                    if (res.code != 200) {
                      this.loading = !this.loading
                      this.handleError(res)
                    } else {
                      this.typeData = data.list
                      this.itemEx('社内向け当日搬入時間単位搬入品目件数状況')
                    }
                  })
                })
              } else {
                this.$router.push({ path: '/shanaikanrisha/todayItemList', query: { fromDate: fromDate, toDate: toDate, userId: userId, radio: this.radio, dateTime: this.form.dateTime }})
              }
            } else if (this.radio === 4) {
              if (this.checked === true) {
                this.apiPost('shanaikanrisha/TruckTypeSameDayList/truckTypeSameDayList', data).then((res) => {
                  this.handelResponse(res, (data) => {
                    if (res.code != 200) {
                      this.loading = !this.loading
                      this.handleError(res)
                    } else {
                      this.typeData = data.list
                      this.truckEx('社内向け指定日搬入時間単位搬入トラック台数状況')
                    }
                  })
                })
              } else {
                this.$router.push({ path: '/shanaikanrisha/todayTruckList', query: { fromDate: fromDate, toDate: toDate, userId: userId, radio: this.radio, dateTime: this.form.dateTime }})
              }
            } else if (this.radio === 5) {
              if (this.checked === true) {
                this.apiPost('shanaikanrisha/ItemTypeList/itemTypeList', data).then((res) => {
                  this.handelResponse(res, (data) => {
                    if (res.code != 200) {
                      this.loading = !this.loading
                      this.handleError(res)
                    } else {
                      this.typeData = data.list
                      this.itemEx('社内向け指定日搬入時間単位予約搬入品目件数状況')
                    }
                  })
                })
              } else {
                this.$router.push({ path: '/shanaikanrisha/itemList', query: { fromDate: fromDate, toDate: toDate, userId: userId, radio: this.radio, dateTime: this.form.dateTime }})
              }
            } else if (this.radio === 6) {
              if (this.checked === true) {
                this.apiPost('shanaikanrisha/TruckTypeList/truckTypeList', data).then((res) => {
                  this.handelResponse(res, (data) => {
                    if (res.code != 200) {
                      this.loading = !this.loading
                      this.handleError(res)
                    } else {
                      this.typeData = data.list
                      this.truckEx('社内向け当日搬入時間単位予約トラック台数状況')
                    }
                  })
                })
              } else {
                this.$router.push({ path: '/shanaikanrisha/truckList', query: { fromDate: fromDate, toDate: toDate, userId: userId, radio: this.radio, dateTime: this.form.dateTime }})
              }
            }
            this.checked = false
            this.radio2 = ''
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    },
    created() {
      if (this.$route.query.radio !== undefined) {
        this.radio = this.$route.query.radio
        if (this.$route.query.radio === '1') {
          this.radio = 1
        } else if (this.$route.query.radio === '2') {
          this.radio = 2
        } else if (this.$route.query.radio === '3') {
          this.radio = 3
        } else if (this.$route.query.radio === '4') {
          this.radio = 4
        } else if (this.$route.query.radio === '5') {
          this.radio = 5
        } else if (this.$route.query.radio === '6') {
          this.radio = 6
        } else {
          this.radio = this.$route.query.radio
        }
      }
      if (this.$route.query.fromDate !== undefined && this.$route.query.toDate !== undefined) {
        var str = this.$route.query.fromDate
        str = str.substr(0, 4) + '/' + str.substr(4, 2) + '/' + str.substr(6, 2)
        var date = new Date(str)
        var str2 = this.$route.query.toDate
        str2 = str2.substr(0, 4) + '/' + str2.substr(4, 2) + '/' + str2.substr(6, 2)
        var date2 = new Date(str2)
        this.form.dateTime = [date, date2]
      }
    },
    mixins: [http]
  }
</script>
<style>
  @import url("../../assets/css/common.css");

  .grid-content-sh {
    text-align: left;
    height: auto;
    padding: 4px 0;
  }
  .grid-content2-sh {
    text-align: left;
    height: auto;
    padding: 7px 0;
  }

  .bg-purple-sh {
    height: 11em;
    padding: 1em 2em 1.2em 2em;
    background: #E2EBFF;
  }
  .bg-purple2-sh {
    height: 13.5em;
    padding: 1em 2em 1.2em 2em;
    background: #E2EBFF;
  }
  .bg-purple3-sh {
    height: 4em;
    padding: 1em 2em 1.2em 2em;
    background: #E2EBFF;
  }

  .bg-right-purple {
    background: #F5F7F7;
  }

  .bg-head-purple {
    background: #fcfcfc;
  }
  .searchCard-box {
    padding: 20px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 50px auto;
    width: 700px;
    border: 2px solid #8492A6;
  }
  .form {
    padding: 15px 15px 15px 15px;
  }
  .div-style {
    padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/shanaikanrisha/search.vue